
































































































































import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import { sleep, isXcxWeb } from '@ivy/fts/utils'
import showDiv, { closeAll } from '@ivy/fts/showDiv'
import ShareModel from '@/components/shareMod.vue'
import ShareCode from '@/components/shareCode.vue'
import * as weixin from '@ivy/fts/weixin'
import { env } from '@ivy/fts/envInfo/envInfo'
import { addStatistics } from '../require'
import qs from 'qs'
import * as helper from '@/helper'
import * as goodsApi from '@/api/goods'
import { uploadEvent } from '@/api/goods/statistics'
import * as _ from 'underscore'
import EarnList from './earnDalog.vue'

@Component({
  components: {
    CustomerButton: () => import('@ivy/fts/comps/Customer'),
  },
})
export default class FootView extends Vue {
  @Prop() point
  @Prop({ default: {} }) discountData: any
  @Prop() spu: any
  @Prop({ default: {} }) invitationData: any
  @Prop({ default: {} }) listen: any
  @Prop() curSku: any
  @Prop() skus: any[]
  @Prop() attrs: any[]
  @Prop() isLevel: any
  @Prop() isCrm: boolean
  @Prop() tipConfig: any
  @Prop({ default: false }) notFooter: boolean // 是否是footer,区别于详情页还是选着多规格时的底部按钮
  @Prop() isInvitation
  @Prop({ default: 'goodsView' }) pageFrom: string
  @Prop({ default: {} }) skuActivity: any
  @Prop({ default: false }) noLevel: boolean
  @Prop() notAllSelect: boolean
  @Prop() goodsStatus: string
  @Prop({ default: 'buy' }) notFooterType // 多规格时是加入购物车还是立即购买
  @Prop({ default: '' }) cid: any
  // disabledSale: boolean = false
  clickButton: any = _.debounce(this.declickButton, 1000)
  timer: any = null
  showGoldTimer: boolean = false
  showFade: boolean = false // 飞入特效开关
  cartNum: number = 0 // 购物车内商品数量
  listenTitle: string = ''
  isLogin: boolean = false

  beforecreate() {}
  @Watch('showCart', { immediate: true })
  async getCartNum(newV, old) {
    await env.init()
    if (newV && (await env.getIsLogin())) {
      let {
        data: { total_cart },
      } = await goodsApi.getCartCount()
      this.cartNum = total_cart
    }
  }

  @Watch('discountData', { deep: true })
  discountDataChanged(newV) {
    console.log('rrrr', newV)
  }

  @Watch('listen.course_id', { immediate: true })
  courseIdChanged(newV) {
    // console.log('courseId', newV)
    let canListen = this.showListen
    const self = this
    if (newV && canListen) {
      let requestConfig: any = {
        disableLoading: true,
        disableAlert: true,
        disableNetWorkError: true,
      }
      this.$axios
        .get(`/api/goods/shop/search/goods/getCourseFirstTrialTitle`, {
          params: {
            courseId: newV,
            virtualType: this.listen.virtual_type,
          },
          ...requestConfig,
        })
        .then(res => {
          // 在这里处理得到的数据
          this.listenTitle = res.data.first_trail_title
        })
        .catch(err => {})
    } else {
      this.listenTitle = ''
    }
  }

  // 是否是分销商品
  get isDistribution() {
    return this.curSku.isDistributionGoods === 1
  }

  // 是否多规格
  get isMutiSku() {
    return this.skus.length > 1
  }

  get isApp() {
    return env.type === 'ivydad'
  }

  // 是否展示购物车
  get showCart() {
    // 隐藏购物车按钮
    return false
    // if (!['ivydad', 'wx'].includes(env.type)) return false
    // if (this.isInvitationGoods) return false
    // if (this.notFooter && this.notFooterType !== 'cart') return false
    // if (this.spu && this.spu.type !== 'physical') return false
    // if (this.spu && this.spu.scope === 'group_goods') return false
    // if (
    //   this.skus &&
    //   this.skus.length === 1 &&
    //   this.hasVirtualGift(this.skus[0])
    // ) {
    //   return false
    // }
    // // if (this.skus && this.skus.length === 1 && this.skus[0].channel_activity)
    // //   return false
    // if (
    //   this.discountData &&
    //   this.discountData.id &&
    //   this.discountData.type !== 'limit_buy'
    // ) {
    //   return false
    // }

    // if (
    //   this.discountData &&
    //   this.discountData.id &&
    //   this.discountData.type === 'distirbution'
    // ) {
    //   return false
    // }
    // return true
  }

  get isSold() {
    if (this.isSaleOut) return true
    if (this.curSku.already_purchase) return true
    if (this.spu.state === 'unpublished') return true
    return false
  }

  get xcxWeb() {
    return isXcxWeb()
  }

  get canClick() {
    return this.curSku.id
  }

  get CustomerParams() {
    return {
      card_title: this.spu.title,
      card_url: window.location.href,
      card_desc: this.spu.remark,
      card_picture: this.spu && this.spu.cover_pics && this.spu.cover_pics[0],
    }
  }

  get showListen() {
    let listen = +this.spu.id !== 900 && this.listen
    return (
      !this.isCrm &&
      this.listen &&
      !(listen.course_id === 24 && listen.auth_scope === 'all') &&
      listen.href
    )
  }

  get isGroupSku() {
    return this.discountData.activity_type === 'group' && this.discountData.id
  }

  get isSaleOut() {
    // 如果选中了sku
    if (this.curSku && this.curSku.id) {
      return this.curSku.virtualInventoryQty < 1
    }
    // 所有的sku
    return this.skus.reduce((sum, cur) => {
      return !!(cur.virtualInventoryQty <= 0 && sum)
    }, true)
  }

  get isInvitationGoods() {
    let { invitation } = this.$route.query
    return !!invitation
  }

  get discountShowGoldTimer() {
    let end = this.invitationData.discount_end
    let start = this.invitationData.discount_start
    if (!end) return false
    let endTime = +new Date(end.replace(/-/g, '/'))
    let nowTime = +new Date()
    if (endTime <= nowTime) {
      // 已超过倒计时时间,不展示
      return false
    } else if (nowTime < +new Date(start)) {
      return false
    }
    return true
  }

  get goldCompute() {
    if (!this.isInvitation || (this.isInvitation && !this.isLogin)) return true
    if (this.invitationData.discounted_value && this.discountShowGoldTimer) {
      return (
        this.invitationData.discounted_value <= this.invitationData.golds_count
      )
    } else {
      return this.invitationData.gold_value <= this.invitationData.golds_count
    }
  }

  get showPresell() {
    let curActivity =
      Object.keys(this.discountData || {}).length > 0
        ? this.discountData
        : this.skuActivity[this.curSku.id] || {}

    return curActivity.activityType === 'presell' && curActivity.id
  }

  get groupPrice() {
    let curActivity =
      Object.keys(this.discountData || {}).length > 0
        ? this.discountData
        : this.skuActivity[this.curSku.id] || {}
    return (
      // '¥' + this.curSku.salePrice
      '¥' +
      (
        Number((this.curSku.originSalePrice || '').replace('¥', '')) -
        curActivity.discount
      ).toFixed(2)
    )
  }

  get basePrice() {
    // if (this.curSku.channel_activity) {
    //   return '¥' + this.curSku.channel_activity
    // }

    return '¥' + this.curSku.originSalePrice || 0
  }

  get singleObj() {
    // 非拼团
    // if (this.isGroupSku) {
    //   return ''
    // }
    if (this.cid) {
      return {
        text: '立即购买',
        clz: '',
        canBuy: true,
      }
    }

    let hasCurSku = Object.keys(this.curSku).length > 1
    if (this.notAllSelect) {
      return {
        text: '立即购买',
        clz: 'no-click',
        canBuy: false,
      }
    }
    // 如果已选中某个sku
    // console.log(this.curSku, '当前选中的信息')
    if (hasCurSku) {
      // 选中的sku已购买,不能购买
      if (this.curSku.already_purchase) {
        return {
          text: '已购买',
          clz: 'no-click',
          canBuy: false,
          message: '购买失败，商品已购买',
        }
      }
      // 选中的sku已售罄
      if (this.curSku.virtualInventoryQty < 1) {
        return {
          text: this.curSku.isVirtual ? '名额已满' : '已售罄',
          clz: 'no-click dis-show',
          canBuy: false,
          message: this.curSku.isVirtual ? '名额已满' : '购买失败，商品已售罄',
        }
      }
      // 即将开售
      if (this.curSku.planPublishTime) {
        return {
          text: '即将开售',
          clz: 'no-click',
          canBuy: false,
          message: '购买失败，商品即将开售',
        }
      }
      // 选中的sku已下架
      //unpublished 0 未上架
      //published 1 上架
      //part_published 2 商品组部分上架
      if (this.curSku.state === 0) {
        return {
          text: '已下架',
          clz: 'no-click dis-show',
          canBuy: false,
          message: '购买失败，商品已下架',
        }
      }
    }
    // 选中的组合没有对应的sku
    if (!hasCurSku && this.noLevel) {
      return {
        text: '缺货',
        clz: 'no-click',
        canBuy: false,
        message: '购买失败，商品缺货',
      }
    }

    // 未选中sku时，判断spu的数据

    // 转介绍商品
    if (this.isInvitationGoods) {
      if (this.goldCompute) {
        return {
          text: '立即兑换',
          clz: '',
          canBuy: true,
        }
      } else {
        return {
          text: '金币不足',
          clz: 'no-click dis-show',
          canBuy: false,
        }
      }
    }
    let curActivity =
      Object.keys(this.discountData || {}).length > 0
        ? this.discountData
        : this.skuActivity[this.curSku.id] || {}

    // 预售商品
    if (this.showPresell && !this.notFooter) {
      return {
        text: `支付定金：¥${curActivity.deposit}`,
        clz: '',
        canBuy: true,
      }
    }
    let application = curActivity.tag === '限时报名'
    // 选中了某个sku
    if (!this.canClick) {
      if (this.isInvitationGoods) {
        if (this.goldCompute) {
          return {
            text: '立即兑换',
            clz: '',
            canBuy: true,
          }
        } else {
          return {
            text: '金币不足',
            clz: 'no-click dis-show',
            canBuy: false,
          }
        }
      } else {
        return {
          text: application || this.isCrm ? '立即报名' : '立即购买',
          clz: '',
          canBuy: true,
        }
        // return application || this.isCrm ? '立即报名' : '立即购买'
      }
    }

    if (curActivity.content_type === 'will_sale') {
      return {
        text: '即将开售',
        clz: 'no-click',
        canBuy: false,
        message: '购买失败，即将开售',
      }
    }
    // console.log('走到最后返回的立即购买')

    return {
      text: application ? '立即报名' : '立即购买',
      clz: '',
      canBuy: true,
    }
  }

  get hasVirtualGift() {
    return skuInfo => {
      // return (
      //   skuInfo &&
      //   skuInfo.giftsActivity &&
      //   skuInfo.giftsActivity.gift &&
      //   skuInfo.giftsActivity.gift.some(el => el.type !== 'physical')
      // )
      return (
        skuInfo &&
        skuInfo.activities &&
        skuInfo.activities.gift &&
        skuInfo.activities.gift.giftList &&
        skuInfo.activities.gift.giftList.some(el => el.type !== 'physical')
      )
    }
  }

  get cartBtnInfo() {
    let hasCurSku = Object.keys(this.curSku).length > 1
    // 部分没选中
    if (this.notAllSelect) {
      return {
        text: '加入购物车',
        clz: 'no-click',
        canBuy: false,
      }
    }

    // 已选中sku
    if (hasCurSku) {
      // 选中商品为虚拟商品
      if (this.curSku.type !== 'physical') {
        return {
          text: '加入购物车',
          clz: 'no-click',
          canBuy: false,
          message: '添加失败，此商品不支持加车',
        }
      }
      // 选中商品的赠品活动含虚拟商品
      if (this.notFooter && this.hasVirtualGift(this.curSku)) {
        return {
          text: '加入购物车',
          clz: 'no-click',
          canBuy: false,
          message: '添加失败，此商品不支持加车',
        }
      }
      // 选中的sku已售罄
      if (this.curSku.virtualInventoryQty < 1) {
        return {
          text: '已售罄',
          clz: 'no-click',
          canBuy: false,
          message: '添加失败',
        }
      }
      // 即将开售
      if (this.curSku.planPublishTime) {
        return {
          text: '即将开售',
          clz: 'no-click',
          canBuy: false,
          message: '添加失败，此商品不支持加车',
        }
      }
      // 选中的sku已下架
      if (this.curSku.state === 0) {
        return {
          text: '已下架',
          clz: 'no-click',
          canBuy: false,
          message: '添加失败，此商品不支持加车',
        }
      }
      // 渠道优惠
      // if (this.notFooter && this.curSku.channel_activity) {
      //   return {
      //     text: '加入购物车',
      //     clz: 'no-click',
      //     canBuy: false,
      //     message: '添加失败，此商品不支持加车',
      //   }
      // }
    }

    // 选中的组合没有对应的sku
    if (!hasCurSku && this.noLevel) {
      return {
        text: '缺货',
        clz: 'no-click',
        canBuy: false,
      }
    }

    // 如果商品存在非限时折扣活动
    let curActivity =
      Object.keys(this.discountData || {}).length > 0
        ? this.discountData
        : this.skuActivity[this.curSku.id] || {}
    if (curActivity.id && curActivity.activity_type !== 'limit_buy') {
      return {
        text: '加入购物车',
        clz: 'no-click',
        canBuy: false,
        message: '添加失败，此商品不支持加车',
      }
    }

    return {
      text: '加入购物车',
      clz: '',
      canBuy: true,
    }
  }

  get showCartBtn() {
    return (
      this.notFooter ||
      (!this.isSaleOut && (!this.curSku || !this.curSku.planPublishTime))
    )
  }

  async created() {
    await uploadEvent.init()
    this.isLogin = await env.getIsLogin()
  }

  // 展示赚金币列表
  async earnClick() {
    await showDiv(EarnList, {
      show: true,
    })
  }

  async toCourse() {
    // 电商埋点-商品详情页点击试听
    await uploadEvent.sendRecord(
      'Click_GoodsDetail_Audution',
      '',
      {
        GoodsName: this.spu.title,
        SpuID: this.spu.id.toString(),
        SpuType: this.spu.state,
      },
      [
        ['p1', 'SpuID'],
        ['p2', 'SpuType'],
      ]
    )
    // 埋点 点击商详页试听
    await addStatistics({
      event: 'Click_GoodDetails_Audition_H5',
      p1: this.$route.query.nativeFrom, // 页面来源
      p2: this.$route.query.spuId + '_' + this.curSku.id || '',
      p3: this.goodsStatus,
    })
    if (this.listen) {
      if (env.type === 'ivydad') {
        //App端
        await env.init()
        let options = {
          course_type: this.listen.virtual_type,
          content_type: this.listen.content_type,
          from: 'product-details-page',
          id: this.listen.course_id,
        }
        // await this.$emit('intellect-statistics', 'stay')
        await env.toCourseAudition(options)
      } else {
        let listenHref = this.listen.href
        listenHref = this.xcxWeb
          ? listenHref.replace('http:', 'https:').replace('/age3?', '/age3/?')
          : this.listen.href
        let spuId = this.$route.query.spuId
        console.log(
          listenHref,
          'listenHref==========>',
          `${listenHref}&try_listen=1&spuId=${spuId}`
        )
        // 这里sentry报了一个异常
        window.location.href = `${listenHref}&try_listen=1&spuId=${this.$route.query.spuId}`
      }
    }
  }
  async toServicer() {
    await this.uploadServicer()
    // 埋点 客服
    addStatistics({
      event: 'Clcik_GoodDetails_Customer_H5',
      p1: this.$route.query.nativeFrom, // 页面来源
      p2: this.point,
      p3: this.goodsStatus,
    })
    await env.init()
    await env.sobot()
  }

  async uploadServicer() {
    // 电商埋点-商品详情页点击客服
    await uploadEvent.sendRecord(
      'Click_GoodsDetail_Customer',
      '',
      {
        GoodsName: this.spu.title,
        SpuID: this.spu.id.toString(),
        SpuType: this.spu.state,
      },
      [
        ['p1', 'SpuID'],
        ['p2', 'SpuType'],
      ]
    )
  }

  async toCart() {
    // 电商埋点-商品详情页点击去购物车
    await uploadEvent.sendRecord(
      'Click_GoodsDetail_GotoShopingCart',
      '',
      {
        GoodsName: this.spu.title,
        SpuID: this.spu.id.toString(),
        SpuType: this.spu.state,
      },
      [
        ['p1', 'SpuID'],
        ['p2', 'SpuType'],
      ]
    )
    await env.init()
    if (!(await env.getIsLogin())) {
      return await env.login()
    }
    this.$router.push({
      path: '/cart',
      query: {
        navBarHide: '1',
      },
    })
  }

  async setShare() {
    await env.init()
    let loginInfo = (await env.getInfo()) || {}
    let login = loginInfo && loginInfo.logined

    const query = qs.parse(window.location.search.slice(1))
    let link = null
    const memId = (login && login.user && login.user.id) || 0
    if (query && +query._cookieDistributorMemId) {
      query._cookieDistributorMemId = memId
      link = `${window.location.origin}${
        window.location.pathname
      }?${qs.stringify(query)}`
    } else {
      link = encodeURI(
        window.location.href + '&_cookieDistributorMemId=' + memId
      )
    }
    let options = {
      title: `${login ? login.nickname : ''} 分享给你 ${this.spu.title}`,
      desc: this.spu.remark,
      imgUrl: helper.transAliImgResize(this.spu.cover, 66, 66),
      link,
    }
    weixin.weixinShareCallback(options, async f => {
      closeAll()
      this.$emit('shareSuccess')
      showDiv(ShareCode, {
        tipConfig: this.tipConfig,
      })
    })
  }

  // 购买按钮
  async declickButton(text = '') {
    // 电商埋点-商品详情页点击立即购买
    await uploadEvent.sendRecord(
      'Click_GoodsDetail_Buy',
      '',
      {
        GoodsName: this.spu.title,
        SpuID: this.spu.id.toString(),
        SpuType: this.spu.state,
        GoldmallnName: this.$route.query.invitation ? 'Gold' : '',
      },
      [
        ['p1', 'SpuID'],
        ['p2', 'SpuType'],
        ['p4', 'GoldmallnName'],
      ]
    )

    // if ((this.isInvitationGoods && !this.goldCompute) || this.isSold) return
    let singleObj = (this.singleObj || {}) as any
    // 如果是商详页底部的按钮，并且是多规格时，稳定允许弹出选择多规格的弹窗
    if (this.pageFrom === 'goodsView' && this.isMutiSku) {
      if (this.isInvitationGoods && !this.singleObj.canBuy) return
      this.$emit('buttonClick', text, 'buy')
    } else {
      if (singleObj.canBuy) {
        this.$emit('buttonClick', this.cid ? 'collocation' : text, 'buy')
      } else {
        singleObj.message ? this.$Toast(singleObj.message) : ''
      }
    }
  }
  groupClick(text = '') {
    if ((this.isInvitationGoods && !this.goldCompute) || this.isSold) return
    this.$emit('buttonClick', text, 'buy')
  }

  // 加入购物车
  async addCart() {
    if (!this.notFooter) {
      // 电商埋点-商品详情页点击添加购物车
      uploadEvent.sendRecord(
        'Click_GoodsDetail_AddShopingCart',
        '',
        {
          GoodsName: this.spu.title,
          SpuID: this.spu.id.toString(),
          SpuType: this.spu.state,
        },
        [
          ['p1', 'SpuID'],
          ['p2', 'SpuType'],
        ]
      )
    }
    await env.init()
    if (!(await env.getIsLogin())) {
      return await env.login()
    }

    if (+this.cartNum >= 99) {
      return this.$Toast('购物车商品已满，建议您先去结算或清理')
    }

    // 如果是多规格
    if (this.pageFrom === 'goodsView' && this.isMutiSku) {
      this.$emit('buttonClick', '', 'cart')
    } else if (this.notFooter) {
      // 加车-多规格
      if (this.cartBtnInfo && this.cartBtnInfo.canBuy) {
        this.$emit('buttonClick', this.curSku)
      } else {
        let message = this.cartBtnInfo && this.cartBtnInfo.message
        if (message) return this.$Toast(message)
      }
    } else {
      // 加车-单规格
      if (this.showFade === true) return
      if (this.curSku.state !== 1) return this.$Toast('添加失败，商品已下架')
      if (this.isSaleOut) return this.$Toast('添加失败，商品已售罄')
      if (this.discountData.id && this.discountData.type !== 'limit_buy')
        return this.$Toast('添加失败，此商品不支持加车')
      const {
        data: {
          data: { total_cart },
        },
      } = await goodsApi.addToCart({
        sku_id: this.curSku.id,
        num: 1,
        channel_id: this.$route.query.channel_id,
      })
      this.showFade = true
      setTimeout(() => {
        this.showFade = false
        this.cartNum = total_cart
      }, 400)
    }
  }
  async showDistribution() {
    const isLogin = await env.getIsLogin()
    if (!isLogin) {
      return await env.login()
    }
    await uploadEvent.sendRecord(
      'Click_GoodsDetail_ShareEarn',
      '',
      {
        Time: new Date().format('YYYY-MM-DD hh:mm:ss'),
        SkuID: this.curSku.id || '',
      },
      [
        ['p1', 'Time'],
        ['p2', 'SkuID'],
      ]
    )
    if (this.notFooter) {
      this.$emit('showDistributionShare')
    } else {
      if (this.skus.length > 1) {
        this.clickButton()
      } else {
        this.$emit('showDistributionShare')
      }
    }
  }
}
